import AOS from 'aos';
jQuery( document ).ready(function($) {
  AOS.init({
    duration: 1500,
    once: true,
  });
});